import React from 'react';
import { Navbar, Footer, AnnouncementBar } from "../components";

const Refund = () => (
  <>
    <AnnouncementBar />
    <Navbar />
    <div className="container my-4">
      <h2>Refund / Return Policy</h2>
      <ul>
        <li>7-day hassle-free returns for unused items in original packaging.</li>
        <li>Refunds are issued to the original payment method within 5–7 working days.</li>
        <li>For COD, refunds are issued via bank transfer or wallet.</li>
      </ul>
    </div>
    <Footer />
  </>
);

export default Refund;
